import React from 'react'
import _ from 'lodash'
import CONSTANTS from '../../orderflow-constants'
import QuantitySelector from './QuantitySelector'
import LOCALE from '../OrderLocale'

export default class Ticket extends React.Component {
    constructor() {
        super();
        
        this.state = {
            show: false,
           
        };

        
    }
   
    componentDidMount() {
        const timer = setTimeout(() => {
            this.setState({show:true});
        }, 200);
        return () => clearTimeout(timer);
    }

    generatePrice(price) {
        if (price.from === price.to) return price.from;
        else if (price.from && price.to) return price.from + ' - ' + price.to;
        else if (price.from && !price.to) return price.from;
        else if (!price.from && price.to) return price.to;
        else return null;
    }

    generateTicketInteraction(availableTicket) {
        const { maxWebTicketCount,  totalTicketQuantity, minWebTicketCount, isDecrementingPossible, isIncrementingPossible, order, selectedTicket, bioDkActive, ticketQuantityChanged, canIncrementTotalQuantity, incrementTotalQuantity, decrementTotalQuantity, canIncrementTotalPoints, freeSeats, default_tickets, site_type } = this.props;
       
      

        switch (availableTicket.type) {
            case CONSTANTS.ticketType.quantity:
                return <QuantitySelector
                    availableTicket={availableTicket}
                    selectedTicket={selectedTicket}
                    order={order}
                 
                    site_type={site_type }
                    totalTicketQuantity={totalTicketQuantity }
                    minWebTicketCount={minWebTicketCount}
                    maxWebTicketCount={maxWebTicketCount }
                    default_tickets={default_tickets }
                    ticketQuantityChanged={ticketQuantityChanged}
                    isIncrementingPossible={isIncrementingPossible}
                    isDecrementingPossible={isDecrementingPossible }
                    canIncrementTotalQuantity={canIncrementTotalQuantity}
                    incrementTotalQuantity={incrementTotalQuantity}
                    decrementTotalQuantity={decrementTotalQuantity}
                    bioDkActive={bioDkActive}
                    canIncrementTotalPoints={canIncrementTotalPoints}
                    freeSeats={freeSeats}
            />
              
        }
    }

    render() {
        const { availableTicket, appLocale, error, selectedTicket,order } = this.props;
        let price = availableTicket.price ? this.generatePrice(availableTicket.price) + ` ${LOCALE[appLocale].currency}` : null;
        price = availableTicket.points ? availableTicket.points + ` ${LOCALE[appLocale].points}` : null;

        const ticketInteraction = this.generateTicketInteraction(availableTicket);
       
        return (
            <div className="Ticket">
                
                <h3>{availableTicket.name}</h3>
                <div className="price">{price}</div>
                {this.state.show === true && ticketInteraction}
              
            </div>
        )
    }
}